import React from 'react';
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import CockpitPage from '../../features/cockpit/CockpitPage';
import ApprovalsPage from '../../features/approvals/ApprovalsPage';
import ChannelsPage from '../../features/channels/ChannelsPage';
import ConsolePage from '../../features/console/ConsolePage';
import BrainPage from '../../features/brain/BrainPage';
import SettingsPage from '../../features/settings/SettingsPage';
import PlaceholderPage from '../../features/placeholder/PlaceholderPage';
import AgentDetailPage from '../../features/agents/AgentDetailPage';
import SchedulerPage from '../../features/scheduler/SchedulerPage';
import useAppStore from '../../store';
import useApprovals from '../../hooks/useApprovals';

function ApprovalsRoute() {
  const {
    approvals,
    approvalsMode,
    selectedApprovalId,
    setSelectedApproval,
    actOnApproval
  } = useApprovals();

  return (
    <ApprovalsPage
      approvals={approvals}
      mode={approvalsMode}
      selected={selectedApprovalId}
      setSelected={setSelectedApproval}
      onAction={(event, id, action) => {
        event?.stopPropagation();
        actOnApproval(id, action);
      }}
    />
  );
}

function CockpitRoute() {
  const approvals = useAppStore((state) => state.approvals);
  const navigate = useNavigate();

  return (
    <CockpitPage
      approvalCount={approvals.length}
      onOpenApprovals={() => navigate('/approvals')}
    />
  );
}

function AgencyRoutes() {
  return (
    <Routes>
      <Route element={<Navigate replace to="/approvals" />} index />
      <Route element={<CockpitRoute />} path="cockpit" />
      <Route element={<ApprovalsRoute />} path="approvals" />
      <Route
        element={<AgentDetailPage />}
        path="agents/:id"
      />
      <Route element={<SchedulerPage />} path="scheduler" />
      <Route element={<BrainPage />} path="brain" />
      <Route element={<ChannelsPage />} path="channels" />
      <Route element={<ConsolePage />} path="console" />
      <Route element={<SettingsPage />} path="settings" />
      <Route element={<Navigate replace to="/approvals" />} path="*" />
    </Routes>
  );
}

export default AgencyRoutes;